import { Form, type FormInstance } from 'antd'
import { Rule } from 'antd/lib/form'
import { Store } from 'antd/lib/form/interface'

import FormAntd from '@/ui/form/antd/FormAntd'

import { ClientTagModel } from './useClientTagForm'

export type ClientTagFormProps = {
  form: FormInstance<ClientTagModel>
  onFormSubmit?: (values: ClientTagModel) => void
  rule: Rule
  initialValues?: Store
}
export const ClientTagForm = ({
  form,
  onFormSubmit,
  rule,
  initialValues,
}: ClientTagFormProps) => {
  return (
    <FormAntd.Root<ClientTagModel>
      form={form}
      initialValues={initialValues}
      layout="vertical"
      onFinish={onFormSubmit}
      validateTrigger={['onBlur']}
    >
      <div className="grid grid-cols-[1fr_80px] gap-3">
        <Form.Item className="w-full" label="Name" name="name" rules={[rule]}>
          <FormAntd.Input placeholder="Enter tag name" />
        </Form.Item>
        <Form.Item label="Color" name="color" rules={[rule]}>
          <FormAntd.ColorSelect placeholder="Color" />
        </Form.Item>
      </div>
    </FormAntd.Root>
  )
}
